import React from 'react';
import styled from 'styled-components';

import { Image as ImageUI } from '@lt/components';
import ExpandArrows from '@lt/components/icons-react/map/ExpandArrows';

import smallMapPictureWebp from 'src/images/small_map/smallMap.webp';
import smallMapPicturePng from 'src/images/small_map/smallMap.png';
import { i18n } from '@lt/localization';
import {
  TEST_ID_SMALL_MAP,
  TEST_ID_SMALL_MAP_DISCLOSURE_BUTTON,
} from './constants';

interface SmallMapProps {
  // при данном событии должна раскрываться карта
  onClick: () => void;
  // внешняя стилизация компонента
  className?: string;
}

/**
 * Десктопная раскрывашка карты при маленьких мальенькиx размера десктопной версии
 */
export const SmallMap = ({
  onClick,
  className,
}: SmallMapProps): JSX.Element => (
  <Container className={className} data-testid={TEST_ID_SMALL_MAP}>
    <Image
      src={smallMapPictureWebp}
      type="image/webp"
      fallback={smallMapPicturePng}
      alt={i18n.t('search.map.smallMap.imageAlt')}
    />
    <Button onClick={onClick} data-testid={TEST_ID_SMALL_MAP_DISCLOSURE_BUTTON}>
      <Icon />
      {i18n.t('search.map.smallMap.title')}
    </Button>
  </Container>
);

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  padding: 8px;

  width: 100%;
  height: 80px;
`;

const Image = styled(ImageUI)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Button = styled.button`
  width: 100%;
  border: 0;
  padding: 8px;
  border-radius: 2px;
  background: #fff;
  box-shadow: 0px 10px 15px 0px rgba(216, 214, 204, 0.9),
    0px 1px 2px 0px rgba(210, 208, 197, 0.9);
  color: #17181a;
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  z-index: 1;
  cursor: pointer;
`;

const Icon = styled(ExpandArrows)`
  height: 16px;
  margin-right: 6px;

  & path {
    stroke: #17181a;
  }
`;
